import { render } from "./diningDetail.vue?vue&type=template&id=6ccd2a46"
import script from "./diningDetail.vue?vue&type=script&lang=js"
export * from "./diningDetail.vue?vue&type=script&lang=js"

import "./diningDetail.vue?vue&type=style&index=0&id=6ccd2a46&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__